/*client\src\pages\Calendar\Calendarpage.js */

import React from "react";
import { CalendarProvider } from "./state/CalendarContext";
import CalendarPageInner from "./CalendarPageInner";

export default function CalendarPage() {
    return (
        <CalendarProvider>
            <CalendarPageInner />
        </CalendarProvider>
    );
}